<div class="background-signing"></div>

<div class="overlay">

  <div class="login-card">

    <div class="login-left">
      <div class="login-area">
        <img
          *ngIf="dataManager.brandingReady && dataManager.loginlogo"
          [src]="dataManager.loginlogo"
          alt="Logo"
          class="login-logo"
        />
      </div>
    </div>

    <div class="login-right">

      <ng-container *ngIf="topErrorMessage">
        <div *ngFor="let obj of keys1">
          <div *ngFor="let value of obj">
            <p class="error">{{ value }}</p>
          </div>
        </div>
      </ng-container>

      <div class="error mb-2" *ngIf="!topErrorMessage">
        {{ errorMsg }}
      </div>

      <p class="heading2 text-center">Reset Password</p>
      <p class="sub-heading text-center mt-2 px-2">
        Enter the email associated with your account and we'll send a link to reset your password
      </p>

      <div class="form-group">
        <input
          class="form-control"
          type="text"
          id="username"
          placeholder="Email"
          [(ngModel)]="username"
          (keydown)="onKeydown($event)"
          required
        />
      </div>

      <button
        class="bt_signin"
        [disabled]="loadFlag"
        (click)="resetpass()"
      >
        Send Link
        <i *ngIf="loadFlag" class="fa fa-spinner fa-pulse ml-2"></i>
      </button>

      <div class="login-options text-right mt-2">
        <div></div>
        <span class="forgot-link" (click)="back()">Back</span>
      </div>

      <div class="privacy-links mt-4" *ngIf="dataManager.showPrivacyLinks">
        <a href="https://www.payarc.com/privacy-policy" target="_blank">Privacy Policy</a>
        <span>|</span>
        <a href="https://www.payarc.com/company/terms-and-conditions" target="_blank">Terms & Conditions</a>
      </div>

    </div>

  </div>

</div>